<div class="legal-support-container">
  <ng-container *ngIf="!mortgageApplication.hasLegalServiceFree()">
    <p
      class="bo-info-text space-after-paragraph"
      [innerHtml]="referenceDataLabels.SolicitorLegalServiceParagraph | localizeLabel"
    ></p>

    <boi-form-radio-button
      [optionList]="referenceDataOptionLists.AnswerType"
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [labelName]="referenceDataLabels.HaveYouChosenASolicitor"
      [propertyNames]="['SolicitorChosenCode', 'SolicitorSequenceNumber']"
      [contextualHelpName]="'AppQuoteFromOurLegal'"
      [(value)]="mortgageApplication.SolicitorChosenCode"
      (valueChange)="resetSolicitorDetails()"
    >
    </boi-form-radio-button>

    <ng-container *ngIf="isSolicitorAddressFieldVisible()">
      <div class="bo-info-text">
        <p [innerHtml]="referenceDataLabels.SolicitorPostcodeWarning | localizeLabel" class="fs-14"></p>
      </div>

      <div class="details__field d-md-flex align-items-center flex-wrap solicitors-postal-code-container">
        <boi-form-text-input
          [labelName]="referenceDataLabels.PostcodeMandatory"
          [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
          [(value)]="solicitorSearchPostCode"
          [contextualHelpName]="'SearchSolicitorButtonLabel'"
          (valueChange)="solicitorSearchPostCode = solicitorSearchPostCode?.toUpperCase()"
        >
        </boi-form-text-input>

        <button class="primary-button vo-secondary-button-1 ml-md-15" (click)="searchSolicitor()">
          {{ referenceDataLabels.SearchSolicitorButton | localizeLabel }}
        </button>
      </div>

      <ng-container
        *ngIf="(solicitors && isSolicitorListVisible) || contactLMSAnswer === referenceDataOptionLists.AnswerTypeYes"
      >
        <div class="bo-info-text">
          <p [innerHtml]="referenceDataLabels.SolicitorListWarning | localizeLabel" class="fs-14"></p>
        </div>

        <div class="form-element app vo-form-row p-15 solicitors-container">
          <div class="form-label mandatory vo-form-row-left-cell fs-14">
            <label [innerHtml]="referenceDataLabels.SolicitorChoose | localizeLabel"></label>
          </div>

          <div class="form-input-container vo-form-row-right-cell vo-list-view-container">
            <boi-form-listview
              class="solicitor-list vo-list-view-address-h"
              [(selectedValue)]="selectedSolicitor"
              [(dataList)]="solicitors"
            >
            </boi-form-listview>
            <div class="buttons__bar d-flex justify-content-between align-items-center mt-30">
              <button class="secondary-button vo-secondary-button-1" (click)="cantFindSolicitor()">
                {{ referenceDataLabels.SolicitorManuallyEnterButton | localizeLabel }}
              </button>

              <button
                class="primary-button vo-primary-button-1"
                [disabled]="!selectedSolicitor"
                (click)="selectSolicitor()"
              >
                {{ referenceDataLabels.SolicitorSelectButton | localizeLabel }}
              </button>
            </div>
          </div>
        </div>

        <ng-container *ngIf="showContactLMS">
          <boi-form-information-box
            [decoration]="'exclamation-mark'"
            [message]="referenceDataLabels.SolicitorFirmNotShown"
          >
          </boi-form-information-box>

          <boi-form-radio-button
            [optionList]="referenceDataOptionLists.AnswerType"
            [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
            [labelName]="referenceDataLabels.ContactLMS"
            [propertyNames]="['SolicitorFromPanelCode']"
            [(value)]="contactLMSAnswer"
            (valueChange)="showLMSAnswer()"
          >
          </boi-form-radio-button>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-container
    *ngIf="
      mortgageApplication.SolicitorChosenCode === referenceDataOptionLists.AnswerTypeNo &&
      mortgageApplication?.IsApplicationReadOnly
    "
  >
    <boi-form-radio-button
      [optionList]="referenceDataOptionLists.AnswerType"
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [labelName]="referenceDataLabels.WouldYouLikeAQuoteFromOurLegal"
      [propertyNames]="['QuoteFromLegalPartnersCode']"
      [(value)]="mortgageApplication.QuoteFromLegalPartnersCode"
    >
    </boi-form-radio-button>
  </ng-container>

  <ng-container *ngIf="isStatementVisible(isWithoutSolicitorVisible)">
    <boi-form-information-box
      [decoration]="'exclamation-mark'"
      [message]="referenceDataLabels.UnableProceedWithoutSolicitor"
    >
    </boi-form-information-box>
  </ng-container>

  <ng-container *ngIf="wasSolicitorChosenManually()">
    <boi-form-information-box [decoration]="'exclamation-mark'" [message]="referenceDataLabels.SolicitorFirmWarning">
    </boi-form-information-box>
  </ng-container>

  <ng-container *ngIf="contactLMSAnswer === referenceDataOptionLists.AnswerTypeNo">
    <boi-form-information-box
      [decoration]="'exclamation-mark'"
      [message]="referenceDataLabels.UnableProceedWithoutSolicitorFromPanel"
    >
    </boi-form-information-box>
  </ng-container>

  <ng-container *ngIf="isSolicitorLmsReferral() || !!mortgageApplication.SolicitorFromPanelCode">
    <boi-form-text-input
      [labelName]="referenceDataLabels.SolicitorFirmName"
      [propertyNames]="['SolicitorAddress.Name']"
      [isFieldDisabled]="true"
      [(value)]="mortgageApplication.SolicitorAddress.Name"
      [contextualHelpName]="'AppQuoteFromOurLegal'"
    >
    </boi-form-text-input>

    <ng-container *ngIf="isSolicitorChosenFromPanel()">
      <boi-form-information-box [decoration]="'exclamation-mark'" [message]="referenceDataLabels.SolicitorFirmCaveat">
      </boi-form-information-box>
    </ng-container>

    <ng-container *ngIf="isFeesFreeStatementVisible && mortgageApplication.hasLegalServiceFree()">
      <boi-form-information-box
        [decoration]="'exclamation-mark'"
        [includeOkButton]="true"
        [shouldNotLocalize]="true"
        [buttonLabel]="referenceDataLabels.PleaseClickOkText | localizeLabel"
        [buttonDisabled]="mortgageApplication?.IsApplicationReadOnly"
        (buttonClickEvent)="isFeesFreeStatementVisible = false"
        [message]="getFeesFreeStatement()"
      >
      </boi-form-information-box>
    </ng-container>
  </ng-container>

  <ng-container
    *ngIf="
      (!isSolicitorLmsReferral() &&
        isSolicitorFirmNameVisible() &&
        mortgageApplication.SolicitorFromPanelCode === referenceDataOptionLists.AnswerTypeYes) ||
      displayAddressFormForSolicitorChosenManually()
    "
  >
    <boi-form-address
      [mortgageApplication]="mortgageApplication"
      [(address)]="mortgageApplication.SolicitorAddress"
      [addressLine1Required]="true"
      [propertyName]="'SolicitorAddress'"
      [labelName]="referenceDataLabels.AddressOfSolicitorFirm"
      [areFieldsDisabled]="true"
      [showCountryCode]="false"
      [contextualHelpName]="'AppSolicitorAddress'"
      [hideFindAddress]="isSolicitorFromPanel()"
      [isFindAddressButtonDisabled]="mortgageApplication?.IsApplicationReadOnly"
    >
    </boi-form-address>

    <boi-form-text-input
      [labelName]="referenceDataLabels.ContactTelephoneNumber"
      [isFieldDisabled]="true"
      [propertyNames]="['SolicitorAddress.PhoneNumber']"
      [(value)]="mortgageApplication.SolicitorAddress.PhoneNumber"
      [contextualHelpName]="
        mortgageApplication.hasLegalServiceFree() ? 'FirmNameNonLmsReferral' : 'AppSolicitorFirmWarning'
      "
    >
    </boi-form-text-input>

    <boi-form-text-input
      [labelName]="referenceDataLabels.IndividualActing"
      [propertyNames]="['IndividualActing']"
      [(value)]="mortgageApplication.IndividualActing"
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [contextualHelpName]="
        mortgageApplication.hasLegalServiceFree() ? 'FirmNameNonLmsReferral' : 'AppSolicitorFirmWarning'
      "
    >
    </boi-form-text-input>

    <boi-form-text-input
      [labelName]="referenceDataLabels.EmailAddressId"
      [propertyNames]="['SolicitorAddress.Email']"
      [(value)]="mortgageApplication.SolicitorAddress.Email"
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [contextualHelpName]="
        mortgageApplication.hasLegalServiceFree() ? 'FirmNameNonLmsReferral' : 'AppSolicitorFirmWarning'
      "
    >
    </boi-form-text-input>
  </ng-container>
</div>
